import { isEqual, differenceWith, cloneDeep } from 'lodash';
import filtersModel from '@/mixins/filters-model';
import blipModel from '@/mixins/blip-model';
import { mapGetters } from 'vuex';

export default {
  mixins: [
    filtersModel,
    blipModel,
  ],
  data() {
    return {
      globalFilterByDataType: {},
    };
  },
  computed: {
    ...mapGetters('filter', [
      'filterByDataType',
    ]),
    filterTitleLabel() {
      return `${this.filterLabel} - ${this.card.props.title}`;
    },
    showClearFilter() {
      return Object.keys(this.appliedFilter).length;
    },
  },
  created() {
    this.globalFilterByDataType = this.filterByDataType[this.card.dataType];

    const isCardFilter = 'filter' in this.card.props;

    if (isCardFilter) {
      this.appliedFilter = cloneDeep(this.card.props.filter);
      this.tempFilter = cloneDeep(this.card.props.filter);
      this.channels = this.tempFilter.channels?.value || [];

      const keysToUse = differenceWith(Object.keys(this.globalFilterByDataType), Object.keys(this.tempFilter), isEqual);

      this.globalFilterByDataTypeToShow = Object.fromEntries(Object.entries(this.globalFilterByDataType).filter(global => keysToUse.includes(global[0])));
    }
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
    clearFilter() {
      this.$emit('applyFilter', {});

      this.closeDialog();
    },
    applyFilter() {
      // Sanatize before send
      for (const filter in this.tempFilter) {
        if (!this.tempFilter[filter] || (!this.tempFilter[filter]?.value && this.tempFilter[filter]?.value?.length)) {
          delete this.tempFilter[filter];
        }
      }

      this.$emit('applyFilter', this.tempFilter);
      this.closeDialog();
    },
    clearChangesFilter() {
      this.tempFilter = cloneDeep(this.appliedFilter);
      this.changeOnPageFilter = false;
    },
  },
};
